module.exports = __webpack_public_path__ + "img/dn.2fc04bf7.webp";